import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "goal-done__firework"
}
const _hoisted_2 = {
  key: 1,
  class: "goal-done__congratulation"
}
const _hoisted_3 = {
  key: 2,
  class: "goal-done__done"
}

import Icon from "@/components/UI/Icon.vue";
import {onMounted, ref} from "vue";
import LikeIcon from "@/components/UI/Icon/LikeIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GoalDone',
  props: {
    color: { default: "#9A9B9C" },
    withoutAnimation: { type: Boolean }
  },
  setup(__props: any) {


const props = __props
const step = ref(props.withoutAnimation ? 3 : 1);
const timeout = (timeout: number) => new Promise(resolve => setTimeout(resolve, timeout));
onMounted(async() => {
  await timeout(1500);
  step.value = 2;
  await timeout(1000);
  step.value = 3;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["goal-done", {done: step.value===3}]),
    style: _normalizeStyle({color: _ctx.color})
  }, [
    (step.value === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "goal-done__firework__spark__left" }, null, -1),
          _createElementVNode("div", { class: "goal-done__firework__progress" }, "100%", -1),
          _createElementVNode("div", { class: "goal-done__firework__spark__right" }, null, -1)
        ])))
      : _createCommentVNode("", true),
    (step.value === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(LikeIcon, { class: "goal-done__congratulation__icon" })
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", null, "Поздравляю!", -1))
        ]))
      : _createCommentVNode("", true),
    (step.value === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createVNode(Icon, {
              name: "done",
              size: 34,
              color: "#FFBA35"
            })
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", null, "Выполнено", -1))
        ]))
      : _createCommentVNode("", true)
  ], 6))
}
}

})